import React, { memo } from 'react';

import { Input } from '../../types/Input';
import { TextInput } from '../TextInput/TextInput';

export const EmailInput = memo((props: Input<string>) => {
  return <TextInput {...props} type="email" />;
});
